import { Receipt } from 'lucide-react';
import type { Expense, ExpenseFormData } from '../../types';
import LoadingSpinner from '../ui/LoadingSpinner';
import ExpenseCard from './ExpenseCard';

interface ExpenseListProps {
  expenses: Expense[];
  loading: boolean;
  error: string | null;
  onUpdate: (id: string, data: Partial<ExpenseFormData>) => Promise<void>;
  onDelete: (id: string) => Promise<void>;
}

export default function ExpenseList({
  expenses,
  loading,
  error,
  onUpdate,
  onDelete,
}: ExpenseListProps) {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="card p-8 text-center">
        <p className="text-red-400 text-sm">{error}</p>
      </div>
    );
  }

  if (expenses.length === 0) {
    return (
      <div className="card p-12 flex flex-col items-center text-center gap-4">
        <div className="w-16 h-16 rounded-2xl bg-slate-800 flex items-center justify-center">
          <Receipt size={28} className="text-slate-600" />
        </div>
        <div>
          <p className="text-slate-300 font-medium">No expenses found</p>
          <p className="text-slate-500 text-sm mt-1">
            Add your first expense or adjust the filters.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {expenses.map(expense => (
        <ExpenseCard
          key={expense.id}
          expense={expense}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
